import { render, staticRenderFns } from "./MapInvestment.vue?vue&type=template&id=486b8f7a&scoped=true"
import script from "./MapInvestment.vue?vue&type=script&lang=js"
export * from "./MapInvestment.vue?vue&type=script&lang=js"
import style0 from "./MapInvestment.vue?vue&type=style&index=0&id=486b8f7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486b8f7a",
  null
  
)

export default component.exports